var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},_vm.$listeners),[_c('path',{attrs:{"d":"M288 448H64V224h64v-64H64c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64v-64h-64v64zm-64-96h224c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }